import React, { useCallback } from 'react';
import { debounce } from "lodash";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import SettingForm from '../../../core/common/dynamic-form/form';
import { useDispatch, useSelector } from "react-redux";
import { getSettingAPI, updateSettingAPI } from "../../../core/data/redux/adminSettingsSlice";
import { getApplicationModulesAPI, createApplicationModuleAPI, deleteApplicationModuleAPI } from "../../../core/data/redux/applicationModulesSlice";
import Api from "../../../core/data/redux/utils/apiCall";
import { API_URLS } from "../../../core/data/redux/apis/urls";
import SettingsData from '../../../core/data/json/settings';
import { buildValidationSchema } from '../../../core/common/dynamic-form/buildValidationSchema';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SettingTest from './settingTest';
import Table from '../../../core/common/dataTable/index';
import { formatDateTime } from '../../../utils/dateUtils';
import { Button, Space, Modal, Form, Input, Switch } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import DeleteModal from '../../../core/modals/deleteModal';
import { isSupportViewer } from '../../../utils/permissionUtils';
import PermissionGuard from '../../permissionGuard';
interface AdminSettingProps {
    type: string;
}

const AdminSetting = ({ type }: AdminSettingProps) => {
    const settingsJson = SettingsData[type] || [];
    const schema = React.useMemo(() => buildValidationSchema(settingsJson), [settingsJson]);
    const dispatch = useDispatch();

    const [formData, setFormData] = React.useState<any>({});
    const [modulesList, setModulesList] = React.useState<any[]>([]);
    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [query, setQuery] = React.useState<string>("");
    const [deleteId, setDeleteId] = React.useState<number | null>(null);
    const [editingModule, setEditingModule] = React.useState<any>(null);
    const [isEditModalVisible, setIsEditModalVisible] = React.useState(false);
    const [isCreateModalVisible, setIsCreateModalVisible] = React.useState(false);
    const [formKey, setFormKey] = React.useState(0);
    const [currentSplashUrl, setCurrentSplashUrl] = React.useState<string | null>(null);
    const [editForm] = Form.useForm();
    const [createForm] = Form.useForm();
    const adminSettingsState = useSelector((state: any) => state.adminSettingsState);
    const applicationModulesState = useSelector((state: any) => state.applicationModulesState);
    console.log(applicationModulesState, 'applicationModulesState')

    const onSubmit = async (data: any) => {
        if (isSupportViewer()) {
            toast.error("Support Viewers are not allowed to update settings.");
            return;
        }

        if (type === "app") {
            if (data.splash_screen) {
                try {
                    const match = data.splash_screen.match(/^data:([^;]+);base64,/);
                    const mime_type = match ? match[1] : "image/png";

                    const payload = {
                        filestring: data.splash_screen,
                        mime_type: mime_type,
                    };

                    const response = await Api.post(API_URLS.MISC.UPDATE_SPLASH_SCREEN, payload);
                    if (response?.data?.success || response?.data?.status === "success" || response?.status === 200 || response?.status === 201) {
                        toast.success("Splash screen updated successfully.");
                        setFormKey(prev => prev + 1);
                        fetchSplashScreen();
                    } else {
                        toast.error("Failed to update splash screen.");
                    }
                } catch (error: any) {
                    toast.error(Api.getErrorMessage(error) || "Failed to update splash screen.");
                }
            } else {
                toast.error("Please select a splash screen image.");
            }
            return;
        }

        const keyValueArray = Object.entries(data).map(([key, value]) => ({
            key,
            value: String(value),
        }));
        const payload = {
            category: type,
            setting: keyValueArray,
        };
        dispatch(updateSettingAPI(payload));
    };

    const fetchApplicationModules = (paginationData?: any, searchQuery?: string) => {
        const page = paginationData?.current || pagination.current;
        const limit = paginationData?.pageSize || pagination.pageSize;
        const searchTerm = searchQuery !== undefined ? searchQuery : query;
        dispatch(getApplicationModulesAPI({ page, limit, query: searchTerm }));
    };

    const debouncedFetchModules = useCallback(
        debounce((p: any, q: string) => {
            fetchApplicationModules(p, q);
        }, 500),
        []
    );

    const handleSearch = (searchQuery: string) => {
        setQuery(searchQuery);
        const resetPagination = {
            ...pagination,
            current: 1,
        };
        setPagination(resetPagination);

        if (searchQuery === "") {
            debouncedFetchModules.cancel();
            fetchApplicationModules(resetPagination, "");
        } else {
            debouncedFetchModules(resetPagination, searchQuery);
        }
    };

    const fetchSplashScreen = async () => {
        try {
            const res = await Api.post(API_URLS.MISC.GET_SPLASH_SCREEN, {});
            if (res?.data?.data?.url) {
                setCurrentSplashUrl(res.data.data.url);
            }
        } catch (error) {
            console.error("Failed to fetch splash screen", error);
        }
    };

    React.useEffect(() => {
        if (type === "modules") {
            fetchApplicationModules();
        } else {
            dispatch(getSettingAPI({ category: type }));
            if (type === "app") {
                fetchSplashScreen();
            }
        }
    }, [type, dispatch]);

    // Handle application modules data
    React.useEffect(() => {
        if (type === "modules" && applicationModulesState?.loading === "fulfilled" && applicationModulesState?.action === "list") {
            // The API response payload from the slice is likely { data: [...], total: X } OR just the array
            const payload = applicationModulesState?.data || {};
            const modulesData = payload?.data || (Array.isArray(payload) ? payload : []);
            const paginationInfo = payload;

            console.log('Payload Data:', payload);
            console.log('Modules Data:', modulesData);

            if (modulesData && modulesData.length > 0) {
                const dataList = modulesData.map((item: any) => ({
                    id: item.id,
                    name: item.name || '',
                    slug: item.slug || '',
                    hindi_name: item.hindi_name || '',
                    description: item.description || '',
                    status: item.status,
                    created_at: item.created_at,
                    modified_at: item.modified_at,
                    deleted_at: item.deleted_at,
                    created_by: item.created_by,
                    updated_by: item.updated_by,
                    key: item.id,
                }));
                setModulesList(dataList);

                setPagination({
                    current: paginationInfo.page || pagination.current,
                    pageSize: paginationInfo.limit || pagination.pageSize,
                    total: paginationInfo.total || modulesData.length || 0
                });
            } else {
                setModulesList([]);
            }
        }
    }, [applicationModulesState, type]);

    // Handle create/update success (using same API endpoint)
    React.useEffect(() => {
        if (type === "modules" && applicationModulesState?.loading === "fulfilled" && applicationModulesState?.action === "create") {
            // Check if it was an update (editingModule exists) or create
            if (editingModule) {
                toast.success(applicationModulesState?.data?.message || 'Module updated successfully');
                setIsEditModalVisible(false);
                setEditingModule(null);
                editForm.resetFields();
            } else {
                toast.success(applicationModulesState?.data?.message || 'Module created successfully');
                setIsCreateModalVisible(false);
                createForm.resetFields();
            }
            fetchApplicationModules();
        } else if (type === "modules" && applicationModulesState?.loading === "rejected" && applicationModulesState?.action === "create") {
            // Extract error message - check multiple possible locations
            const errorMessage = applicationModulesState?.error
                || applicationModulesState?.data?.message
                || (editingModule ? 'Failed to update module' : 'Failed to create module');
            toast.error(errorMessage);
        }
    }, [applicationModulesState, type, editingModule]);

    // Handle delete success
    React.useEffect(() => {
        if (type === "modules" && applicationModulesState?.loading === "fulfilled" && applicationModulesState?.action === "delete") {
            toast.success(applicationModulesState?.data?.message || 'Module deleted successfully');
            setDeleteId(null);
            fetchApplicationModules();
        } else if (type === "modules" && applicationModulesState?.loading === "rejected" && applicationModulesState?.action === "delete") {
            toast.error(applicationModulesState?.error || 'Failed to delete module');
            setDeleteId(null);
        }
    }, [applicationModulesState, type]);

    React.useEffect(() => {
        if (type !== "modules" && adminSettingsState?.data?.data?.data?.length > 0) {
            const settings = adminSettingsState.data.data?.data?.reduce((acc: any, item: any) => {
                acc[item.key] = item.value;
                return acc;
            }, {});
            setFormData(settings);
        }
    }, [adminSettingsState, type]);

    const handlePagination = (paginationData: any, filters?: any, sorter?: any) => {
        setPagination({
            current: paginationData.current,
            pageSize: paginationData.pageSize,
            total: paginationData.total || pagination.total
        });
        fetchApplicationModules(paginationData, query);
    };

    const handleEdit = (record: any) => {
        setEditingModule(record);
        editForm.setFieldsValue({
            id: record.id,
            name: record.name,
            slug: record.slug,
            hindi_name: record.hindi_name,
            description: record.description,
            status: record.status
        });
        setIsEditModalVisible(true);
    };

    const handleCreate = async () => {
        try {
            const values = await createForm.validateFields();
            dispatch(createApplicationModuleAPI({
                name: values.name,
                slug: values.slug,
                hindi_name: values.hindi_name,
                description: values.description,
                status: values.status !== undefined ? values.status : true
            }));
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    const handleUpdate = async () => {
        try {
            const values = await editForm.validateFields();
            dispatch(createApplicationModuleAPI({
                id: values.id,
                name: values.name,
                slug: values.slug,
                hindi_name: values.hindi_name,
                description: values.description,
                status: values.status
            }));
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    const handleDelete = (response: string) => {
        if (response === "YES" && deleteId) {
            dispatch(deleteApplicationModuleAPI({ id: deleteId }));
        } else {
            setDeleteId(null);
        }
    };

    React.useEffect(() => {
        if (adminSettingsState?.loading === "fulfilled" && adminSettingsState?.action === "update") {
            if (adminSettingsState?.data?.data?.length > 0) {
                const settings = adminSettingsState.data.data?.reduce((acc: any, item: any) => {
                    acc[item.key] = item.value;
                    return acc;
                }, {});
                setFormData(settings);
            }

            toast.success(adminSettingsState?.data?.message);
        } else if (adminSettingsState?.loading === "rejected") {
            toast.error(adminSettingsState?.error || "Failed to update settings");
        }
    }, [adminSettingsState, type, dispatch]);

    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "id",
            width: 100,
            render: (text: string, record: any, index: number) => (
                <div>
                    {(pagination.current) ? (index + pagination.current * pagination.pageSize - pagination.pageSize + 1) : (index + 1)}
                </div>
            ),
        },
        {
            title: "ID",
            dataIndex: "id",
            width: 100,
        },
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Slug",
            dataIndex: "slug",
        },
        {
            title: "Hindi Name",
            dataIndex: "hindi_name",
        },
        {
            title: "Description",
            dataIndex: "description",
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (value: boolean) => (
                <span style={{ color: value ? 'green' : 'red' }}>
                    {value ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            render: (text: string) => text ? formatDateTime(text) : '-',
        },
        {
            title: "Modified At",
            dataIndex: "modified_at",
            render: (text: string) => text ? formatDateTime(text) : '-',
        },
    ...(!isSupportViewer()
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            width: 120,
            render: (_: any, record: any) => (
              <Space>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(record)}
                  size="small"
                />
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#delete_modal"
                  onClick={() => setDeleteId(record.id)}
                >
                  <i className="ti ti-trash" style={{ color: '#ff4d4f', fontSize: '16px' }} />
                </Link>
              </Space>
            ),
          },
        ]
      : []),
  ];


    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Settings</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="#">Settings</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page" style={{ textTransform: 'capitalize' }}>
                                        {type === "modules" ? "Application Modules" : `${type} Settings`}
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>

                    {type === "modules" ? (
                        // Table view for modules
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <h5 className="card-title mb-0">Application Modules List</h5>
                                        <PermissionGuard route="settings/add-module">
                                            <Button
                                                type="primary"
                                                icon={<PlusOutlined />}
                                                onClick={() => setIsCreateModalVisible(true)}
                                            >
                                                Add New Application
                                            </Button>
                                        </PermissionGuard>
                                    </div>
                                    <div className="card-body p-0 py-3">
                                        <Table
                                            columns={columns}
                                            dataSource={modulesList}
                                            Selection={false}
                                            paginationConfig={pagination}
                                            handlePagination={handlePagination}
                                            loading={applicationModulesState?.loading === 'pending'}
                                            handleSearch={handleSearch}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        // Form view for other settings
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <h5 className="card-title mb-0">{type} Settings</h5>
                                        {['smtp', 'sms', 'storage'].includes(type) && <SettingTest type={type} />}
                                    </div>
                                    <div className="card-body">
                                        {type === "app" && currentSplashUrl && (
                                            <div className="mb-4">
                                                <h6>Current Splash Screen</h6>
                                                <img 
                                                    src={currentSplashUrl} 
                                                    alt="Current Splash Screen" 
                                                    style={{ maxHeight: '200px', border: '1px solid #ddd', borderRadius: '8px', marginTop: '10px' }} 
                                                />
                                            </div>
                                        )}
                                        <SettingForm key={formKey} schema={schema} onSubmit={onSubmit} formData={formData} formJson={settingsJson} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Edit Modal */}
                    {type === "modules" && (
                        <Modal
                            title="Edit Application Module"
                            open={isEditModalVisible}
                            onOk={handleUpdate}
                            onCancel={() => {
                                setIsEditModalVisible(false);
                                setEditingModule(null);
                                editForm.resetFields();
                            }}
                            confirmLoading={applicationModulesState?.loading === 'pending' && applicationModulesState?.action === 'create'}
                            okText="Update"
                            cancelText="Cancel"
                        >
                            <Form form={editForm} layout="vertical">
                                <Form.Item name="id" hidden>
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    name="name"
                                    label="Name"
                                    rules={[{ required: true, message: "Please input name!" }]}
                                >
                                    <Input placeholder="Enter name" />
                                </Form.Item>
                                <Form.Item
                                    name="slug"
                                    label="Slug"
                                    normalize={(value) => value ? value.toLowerCase().replace(/\s/g, '') : value}
                                    rules={[
                                        { required: true, message: "Please input slug!" },
                                        {
                                            pattern: /^[a-z0-9_-]+$/,
                                            message: "Slug must contain only lowercase letters, numbers, underscores, and hyphens. No spaces allowed."
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter slug (e.g., user_management)" />
                                </Form.Item>
                                <Form.Item
                                    name="hindi_name"
                                    label="Hindi Name"
                                    rules={[
                                        { required: true, message: "Please input Hindi Name!" },
                                        {
                                            pattern: /^[\u0900-\u097F0-9\s.,!?@#&()\-_:;"'/%]+$/,
                                            message: "Only Hindi text, numbers, and common special characters are allowed."
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Hindi Name" />
                                </Form.Item>
                                <Form.Item
                                    name="description"
                                    label="Description"
                                >
                                    <Input.TextArea
                                        placeholder="Enter description"
                                        rows={3}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="status"
                                    label="Status"
                                    valuePropName="checked"
                                >
                                    <Switch
                                        checkedChildren="Active"
                                        unCheckedChildren="Inactive"
                                    />
                                </Form.Item>
                            </Form>
                        </Modal>
                    )}

                    {/* Delete Modal */}
                    {type === "modules" && (
                        <DeleteModal handleDelete={handleDelete} />
                    )}

                    {/* Create Modal */}
                    {type === "modules" && (
                        <Modal
                            title="Add New Application Module"
                            open={isCreateModalVisible}
                            onOk={handleCreate}
                            onCancel={() => {
                                setIsCreateModalVisible(false);
                                createForm.resetFields();
                            }}
                            confirmLoading={applicationModulesState?.loading === 'pending' && applicationModulesState?.action === 'create'}
                            okText="Create"
                            cancelText="Cancel"
                        >
                            <Form form={createForm} layout="vertical">
                                <Form.Item
                                    name="name"
                                    label="Name"
                                    rules={[{ required: true, message: "Please input name!" }]}
                                >
                                    <Input placeholder="Enter name (e.g., user_management)" />
                                </Form.Item>
                                <Form.Item
                                    name="slug"
                                    label="Slug"
                                    normalize={(value) => value ? value.toLowerCase().replace(/\s/g, '') : value}
                                    rules={[
                                        { required: true, message: "Please input slug!" },
                                        {
                                            pattern: /^[a-z0-9_-]+$/,
                                            message: "Slug must contain only lowercase letters, numbers, underscores, and hyphens. No spaces allowed."
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter slug (e.g., plpplp)" />
                                </Form.Item>
                                <Form.Item
                                    name="hindi_name"
                                    label="Hindi Name"
                                    rules={[{ required: true, message: "Please input Hindi name!" }]}
                                >
                                    <Input placeholder="Enter Hindi name" />
                                </Form.Item>
                                <Form.Item
                                    name="description"
                                    label="Description"
                                >
                                    <Input.TextArea
                                        placeholder="Enter description"
                                        rows={3}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="status"
                                    label="Status"
                                    valuePropName="checked"
                                    initialValue={true}
                                >
                                    <Switch
                                        checkedChildren="Active"
                                        unCheckedChildren="Inactive"
                                    />
                                </Form.Item>
                            </Form>
                        </Modal>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminSetting;